import {TreeItemLink} from "./tree-item-link";

export class TreeLinks {
    domNode: [];
    rtl = false;
    urlTemplate = null;
    treeItems: Array<TreeItemLink> = [];

    constructor(nodes, rtl = false,  urlTemplate = null) {
        this.domNode = nodes;
        this.rtl = rtl;
        this.urlTemplate = urlTemplate;
    }

    init(parent = null) {
        this.findTreeItems(this.domNode, this, parent);
    }

    findTreeItems(node, tree: TreeLinks, parent: TreeItemLink) {
        let itemLink;
        for(let i = 0; i < node.length; i++) {
            itemLink = new TreeItemLink(node[i], parent, this, this.rtl, this.urlTemplate);
            tree.treeItems.push(itemLink);
        }
    }

    setFocusToItem(treeItem) {
        for (let i = 0; i < this.treeItems.length; i++) {
            let ti = this.treeItems[i];
            if (ti === treeItem) {
                ti.setFocus();
            }
        }
    }

    setFocusToNextItem(currentItem, innerFocus = true) {
        if(currentItem.isExpanded && innerFocus) {
            currentItem.tree.treeItems[0].setFocus();
        } else {
            let index = this.treeItems.findIndex(item => item == currentItem);
            if(index + 1 < this.treeItems.length) {
                this.treeItems[index + 1].setFocus();
            } else {
                if(currentItem.parent) {
                    currentItem.parent.groupTreeItem.setFocusToNextItem(currentItem.parent, false);
                }
            }
        }
    }

    setFocusToPreviousItem(currentItem: TreeItemLink) {
        let index = this.treeItems.findIndex(item => item == currentItem);
        if(index > 0) {
            this.treeItems[index - 1].setFocusToLastItem(this.treeItems[index - 1]);
        } else {
            if(currentItem.parent) {
                currentItem.parent.setFocus();
            }
        }
    }




    expandAllSiblingItems() {
        for (let i = 0; i < this.treeItems.length; i++) {
            let ti = this.treeItems[i];
            if (ti.tree) {
                ti.expandNode(ti);
            }
        }
    }


    setFocusByFirstCharacter(currentItem, char) {
        let foundNode = null;
        let node;

        while (!foundNode && node != currentItem) {
            node = node || currentItem;
            node = node.groupTreeItem.getNextCheck(node);
            if(node.getFirstChar() == char) {
                foundNode = node;
                foundNode.setFocus();
            }
        }

    }

    getNextCheck(currentItem, checkInner= true) {
        if(checkInner && currentItem.isExpanded ) {
            return currentItem.tree.treeItems[0];
        }
        let index = this.treeItems.findIndex(item => item == currentItem);
        if(index + 1 < this.treeItems.length) {
            return this.treeItems[index + 1];
        }
        if(currentItem.parent) {
            return currentItem.parent.groupTreeItem.getNextCheck(currentItem.parent, false);
        }
        return TreeLinks.getRoot(currentItem).treeItems[0];
    }


    static setFocusToLastTreeItem(node){
        this.getLastNode(TreeLinks.getRoot(node).treeItems).setFocus();
    }

    static setFocusToFirstTreeItem(node) {
        TreeLinks.getRoot(node).treeItems[0].setFocus();
    }

    static getLastNode(tree: Array<TreeItemLink>) {
        if(tree[tree.length - 1].isExpanded) {
            return TreeLinks.getLastNode(tree[tree.length - 1].tree.treeItems);
        }
        return tree[tree.length - 1];
    }

    static getRoot(node: TreeItemLink) {
        return node.parent? TreeLinks.getRoot(node.parent) : node.groupTreeItem;
    }

    setActiveByProperty(property, value) {
        let node = this.findItem(this.treeItems, property, value);
        if(node) {
            this.setNodePathActive(node);
            return node;
        }
        return false;
    }

    setNodePathActive(node) {
        node.expandNode(node);
        if(node.parent) {
            this.setNodePathActive(node.parent);
        }
    }

    findItem(treeLinks, property, value) {
        for(let i = 0; i < treeLinks.length; i++) {
            if(treeLinks[i].data[property] == value) {
                return treeLinks[i];
            }
            if(treeLinks[i].tree) {
                let res = this.findItem(treeLinks[i].tree.treeItems, property, value);
                if(res) {
                    return res;
                }
            }
        }
    }

    getNodeBreadcrumbs(node) {
        let breadcrumbs = [];
        if(node) {
            while (node) {
                breadcrumbs.unshift(node.data);
                node = node.parent;
            }
            return   breadcrumbs;
        }
        return;
    }
}
